module.exports = __webpack_public_path__ + "img/0-24.d777372c.gif";